import React, { useContext, useRef, useEffect, useState } from "react";
import { VariantContextData } from "../variants/VariantBuilderContext";

const ElementSpacingHandle = (props) => {
  const handle = useRef(null);
  const [contextData] = useContext(VariantContextData);

  const direction = props.direction;
  const directionCapitalized =
    direction == "top"
      ? "Top"
      : direction == "bottom"
      ? "Bottom"
      : direction == "left"
      ? "Left"
      : "Right";
  const element = props.element;
  const isMobile = contextData.device == "mobile";
  const elementDivSelector = `#builder .cf-element[data-object-id="${element.id}"]`;
  const defaultValue =
    !isMobile || _.isNil(element.options[`padding-mobile-${direction}`])
      ? element.options[`padding-${direction}`]
      : element.options[`padding-mobile-${direction}`];
  const [value, setValue] = useState(defaultValue);

  const handleDrag = (e) => {
    e.preventDefault();

    let oldValue;
    let newValue;
    const elementDiv = document.querySelector(elementDivSelector);
    const style = window.getComputedStyle(elementDiv);

    if (direction == "top") {
      oldValue = parseInt(style[`paddingTop`].replace(" !important", "") || 0);
      newValue = oldValue + e.movementY;
    }

    if (direction == "bottom") {
      oldValue = parseInt(style[`paddingBottom`].replace(" !important", "") || 0);
      newValue = oldValue + e.movementY;
    }

    if (direction == "left") {
      oldValue = parseInt(style[`paddingLeft`].replace(" !important", "") || 0);
      newValue = oldValue + e.movementX;
    }

    if (direction == "right") {
      oldValue = parseInt(
        style[`paddingRight`].replace(" !important", "") || 0
      );
      newValue = oldValue - e.movementX;
    }

    if (newValue >= 0) {
      elementDiv.style.setProperty(
        `padding-${direction}`,
        `${newValue}px`,
        "important"
      );
      elementDiv.classList.add("spacing");
      setValue(newValue);
    }
  };

  const handleUpdate = () => {
    document.removeEventListener("mousemove", handleDrag);
    document.removeEventListener("mouseup", handleUpdate);

    const elementDiv = document.querySelector(elementDivSelector);
    const newPosition = parseInt(
      elementDiv.style[`padding${directionCapitalized}`]
        .replace("px", "")
        .replace(" !important", "")) || 0;

    elementDiv.style.removeProperty(`padding-${direction}`);
    elementDiv.classList.remove("spacing");

    dispatchCustomEvent("updateBuilder", {
      updates: [
        {
          object_type: "elements",
          object_id: element.id,
          setting_name: `[options][padding${
            isMobile ? "-mobile" : ""
          }-${direction}]`,
          value: newPosition,
          old_value: defaultValue,
        },
      ],
    });
  };

  const syncSpacingHandleFromContext = function () {
    // Automatically update the value from the context when changing the device
    const desktopValue = element.options[`padding-${direction}`];
    const mobileValue = element.options[`padding-mobile-${direction}`];

    if (isMobile && mobileValue) {
      setValue(parseInt(mobileValue));
    } else if (desktopValue) {
      setValue(parseInt(desktopValue));
    }
  }

  useEffect(() => {
    syncSpacingHandleFromContext();
  }, [contextData.device]);

  return (
    <div
      ref={handle}
      className="element-spacing-wrapper"
      style={{
        display: contextData.selected_object_type == "elements" && contextData.selected_object_id == element.id ? "flex" : "none",
        position: "absolute",
        top: ["left", "right"].includes(direction) ? 0 : undefined,
        left: ["top", "bottom"].includes(direction) ? 0 : undefined,
        right: ["top", "bottom"].includes(direction) ? 0 : undefined,
        [direction]: 0,
        width: direction === "top" || direction === "bottom" ? "100%" : "10px",
        height: direction === "left" || direction === "right" ? "100%" : "10px",
        cursor:
          direction === "top" || direction === "bottom"
            ? "ns-resize"
            : "ew-resize",
        zIndex: 10,
        justifyContent: "center",
        alignItems: "center"
      }}
      onMouseDown={(e) => {
        document.addEventListener("mousemove", handleDrag);
        document.addEventListener("mouseup", handleUpdate);
      }}
    >
      <div
        className={`element-spacing-handle !w-[25px] !min-w-[25px] !h-[7px] bg-white shadow border-solid border-[1px] border-slate-300 rounded ${
          ["left", "right"].includes(direction) ? "rotate-90" : ""
        } ${
          direction == "top"
            ? "mt-[-5px]"
            : direction == "bottom"
            ? "mb-[-5px]"
            : direction == "left"
            ? "ml-[-5px]"
            : "mr-[-5px]"
        }`}
      ></div>
      <div className={`hidden element-spacing-value text-xl opacity-80 ${direction == 'top' ? 'mt-[10px]' : direction == 'bottom' ? 'mb-[10px]' : direction == 'left' ? 'ml-[30px]' : 'mr-[30px]'}`}>
        {`${value || 0}px`}
      </div>
    </div>
  );
};

export default ElementSpacingHandle;
